// extracted by mini-css-extract-plugin
export default {"container":"xbGk9e","description":"yV6RLp","descriptionOutbound":"KACD9S","buttonLabel":"p4NJCE","button":"sYop98","descriptionText":"MBiPtx","wrapperLink":"THRbpu"};